import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

import { GET_FOLDERS_QUERY } from '@/hooks/queries/use-get-folders'
import { useAuth } from '@/hooks/use-auth'
import { createFolder } from '@/services/create-folder'
import { queryClient } from '@/services/query-client'

interface CreateFolderPayload {
  name: string
  description: string
}

type HandleErrorMessage = (error: { title: string; message: string }) => void

export const useCreateFolder = (handleErrorMessage: HandleErrorMessage) => {
  const { user } = useAuth()

  const mutation = useMutation(
    (payload: CreateFolderPayload) =>
      createFolder({
        ownerid: user.id,
        ...payload,
        updatedAt: new Date().toISOString(),
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([GET_FOLDERS_QUERY])
      },
      onError(error) {
        if (axios.isAxiosError(error))
          switch (error.response?.status) {
            case 403:
              return handleErrorMessage({
                title: 'Acesso negado',
                message: 'Sem permissão para adicionar pastas',
              })
          }
        handleErrorMessage({
          title: 'Erro',
          message: 'Algo deu errado e sua pasta não foi adicionada',
        })
      },
    },
  )

  return mutation
}
